import { createRef, createElement, Component } from 'react';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
}

window.requestIdleCallback = window.requestIdleCallback || function (cb) {
  var start = Date.now();
  return setTimeout(function () {
    cb({
      didTimeout: false,
      timeRemaining: function timeRemaining() {
        return Math.max(0, 50 - (Date.now() - start));
      }
    });
  }, 1);
};

window.cancelIdleCallback = window.cancelIdleCallback || function (id) {
  clearTimeout(id);
};

var isIntersectionObserverAvailable = function isIntersectionObserverAvailable() {
  return 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window;
};

var Img =
/** @class */
function (_super) {
  __extends(Img, _super);

  function Img(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      isVisible: !isIntersectionObserverAvailable(),
      isLoaded: !isIntersectionObserverAvailable(),
      opacity: 0
    };

    _this.handleIntersection = function (entries) {
      if (!entries[0].isIntersecting) {
        return;
      }

      var _a = _this.props,
          _b = _a.fallback,
          offset = _a.offset,
          transition = _a.transition,
          attributes = __rest(_a, ["fallback", "offset", "transition"]);

      var img = new Image();
      Object.assign(img, attributes);

      img.onload = function () {
        _this.setState({
          isLoaded: true
        });
      };

      _this.observer.unobserve(_this.ref.current);
    };

    _this.handleTransitionEnd = function () {
      _this.idleCallbackId = window.requestIdleCallback(function () {
        _this.setState({
          isVisible: true
        });

        _this.idleCallbackId = undefined;
      }, {
        timeout: 3000
      });
    };

    _this.ref = createRef();
    return _this;
  }

  Img.prototype.componentDidMount = function () {
    if (!isIntersectionObserverAvailable()) {
      return;
    }

    this.observer = new IntersectionObserver(this.handleIntersection, {
      rootMargin: this.props.offset + 'px'
    });
    this.observer.observe(this.ref.current);
  };

  Img.prototype.componentDidUpdate = function () {
    if (this.state.isLoaded && !this.state.opacity) {
      this.setState({
        opacity: 1
      });
    }
  };

  Img.prototype.componentWillUnmount = function () {
    if (this.idleCallbackId) {
      window.cancelIdleCallback(this.idleCallbackId);
      this.idleCallbackId = undefined;
    }
  };

  Img.prototype.render = function () {
    var _a = this.props,
        fallback = _a.fallback,
        style = _a.style,
        transition = _a.transition,
        className = _a.className,
        props = __rest(_a, ["fallback", "style", "transition", "className"]);

    var _b = this.state,
        isVisible = _b.isVisible,
        isLoaded = _b.isLoaded,
        opacity = _b.opacity;

    var imgStyle = _assign({
      display: 'inline-block',
      verticalAlign: 'bottom',
      width: props.width,
      height: props.height
    }, style);

    var containerStyle = {
      width: imgStyle.width,
      height: imgStyle.height,
      position: 'relative'
    };
    var imgContainerStyle = {
      top: 0,
      left: 0,
      position: 'absolute',
      opacity: opacity,
      transition: transition
    };

    if (isVisible) {
      return createElement("img", _assign({}, props, {
        style: imgStyle,
        className: className
      }));
    }

    return createElement("div", {
      style: containerStyle,
      ref: this.ref,
      className: isLoaded ? '' : className
    }, fallback(), createElement("div", {
      style: imgContainerStyle,
      onTransitionEnd: this.handleTransitionEnd
    }, isLoaded && createElement("img", _assign({}, props, {
      style: imgStyle,
      className: className
    }))));
  };

  Img.defaultProps = {
    offset: 500,
    transition: 'opacity 0.3s ease-in',
    fallback: function fallback() {
      return null;
    }
  };
  return Img;
}(Component);

export default Img;